import React, { useEffect, useState } from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import classes from "./WorkSection.module.scss";
import { Button } from "Components/ReactstrapSlim";
import SocialCollabMode, { WorkMode } from "./CollaborateMode";


const WorkSection: React.FC = () => {
   const [mode, setMode] = useState<WorkMode>();
   const [isFullScreen, setIsFullscreen] = useState(false);

   const closeMode = () => {
      setMode(undefined);
   }
   const selectMode = (newMode: WorkMode) => {
      setMode(newMode);
   }
   const renderMode = () => {
      if(!mode)
         return null;
      return <SocialCollabMode workMode={mode} onBookingComplete={closeMode} />
   }

   useEffect(() => {
      const checkFullscreenStatus = () => {
         const fullscreenElement = document.fullscreenElement;
         setIsFullscreen(!!fullscreenElement);
      };

      document.addEventListener('fullscreenchange', checkFullscreenStatus);
      document.addEventListener('webkitfullscreenchange', checkFullscreenStatus);

      return () => {
         document.removeEventListener('fullscreenchange', checkFullscreenStatus);
         document.removeEventListener('webkitfullscreenchange', checkFullscreenStatus);
      }
   }, [])

   return (
      <div className={classNames(classes.module, { [classes.moduleExpanded]: !!mode }, { [classes.moduleExpandedFullScreen]: !!mode && isFullScreen })}>
         {mode != undefined && <>
            <div className={classes.moduleCloseWrapper}>
               <Button color="icon" size="icon" onClick={closeMode} className={classes.moduleClose}><Icons.Close /></Button>                        
            </div>
            {renderMode()}            
         </>}
         {mode == undefined && <>
            <div className={classes.header}>
               Plan an activity
            </div>
            <div className={classes.options}>
               <div className={classes.option} onClick={() => selectMode(WorkMode.Focus)}>
                  <div className={classes.optionTitle}>Focus</div>
                  <div className={classes.optionDescription}>Find a space to concentrate and get stuff done.</div>
               </div>
               <div className={classes.option} onClick={() => selectMode(WorkMode.Cowork)}>
                  <div className={classes.optionTitle}>Cowork</div>
                  <div className={classes.optionDescription}>Work with others in the same location.</div>
               </div>
               <div className={classes.option} onClick={() => selectMode(WorkMode.Collaborate)}>
                  <div className={classes.optionTitle}>Collaborate</div>
                  <div className={classes.optionDescription}>Collaborate in private 1:1s, brainstorms, team meetings.</div>
               </div>
            </div>         
         </>}
      </div>
   );
};

export default WorkSection;